export function linearRegression(x_values: number[], y_values: number[]) {
  // Create the regressor object to store the equation's data
  const regressor: { slope?: number; intercept?: number } = {};

  // Set variables we'll need to get the slope and intercept;
  // we need to find the equation in the format y = m*x+b where m is the slope and b is the intercept
  const x_mean = x_values.reduce((a, b) => a + b, 0) / x_values.length;
  const y_mean = y_values.reduce((a, b) => a + b, 0) / y_values.length;

  // Equations to solve for slope:
  let slope = 0,
    slope_numerator = 0,
    slope_denominator = 0;

  for (let i = 0; i < x_values.length; i++) {
    slope_numerator += (x_values[i] - x_mean) * (y_values[i] - y_mean);
    slope_denominator += Math.pow(x_values[i] - x_mean, 2);
  }

  slope = slope_numerator / slope_denominator;
  regressor.slope = slope;

  // Equation to solve for intercept
  const intercept = y_mean - x_mean * slope;

  regressor.intercept = intercept;

  return regressor;
}
